import type { TranslationKey } from "../state/i18n";
import type { Category } from "../types";
import { keyFromSelector } from "i18next";

export const getCategoryTranslationKey = (category: Category): TranslationKey => {
  switch (category) {
    case "textFields":
      return keyFromSelector(($) => $.FIELD_CATEGORY_TEXT_FIELDS);
    case "layout":
      return keyFromSelector(($) => $.FIELD_CATEGORY_LAYOUT);
    case "choices":
      return keyFromSelector(($) => $.FIELD_CATEGORY_CHOICES);
    case "dateTime":
      return keyFromSelector(($) => $.FIELD_CATEGORY_DATE_TIME);
    case "location":
      return keyFromSelector(($) => $.FIELD_CATEGORY_LOCATION);
    case "media":
      return keyFromSelector(($) => $.FIELD_CATEGORY_MEDIA);
    case "number":
      return keyFromSelector(($) => $.FIELD_CATEGORY_NUMBER);
    case "personalInfo":
      return keyFromSelector(($) => $.FIELD_CATEGORY_PERSONAL_INFO);
    case "searchItems":
      return keyFromSelector(($) => $.FIELD_CATEGORY_SEARCH_ITEMS);
    case "subform":
      return keyFromSelector(($) => $.FIELD_CATEGORY_SUBFORM);
    case "unknown":
      return keyFromSelector(($) => $.FIELD_CATEGORY_UNKNOWN);
  }
};
